import { useState } from "#app";

export const useCreditsModal = () => {
  // 使用 useState 创建全局响应式状态
  const isCreditsModalOpen = useState("isCreditsModalOpen", () => false);
  const requiredCredits = useState("requiredCredits", () => 0);
  const showRequiredCredits = useState("showRequiredCredits", () => false);
  const creditsModalView = useState("creditsModalView", () => "all");

  const normalizeView = (input) => {
    if (typeof input === "string" && input) return input;
    if (input && typeof input === "object" && typeof input.view === "string") {
      return input.view;
    }
    return "all";
  };

  // 打开积分弹窗（购买更多积分）
  const openBuyCreditsModal = (view = "all") => {
    console.log("openBuyCreditsModal");
    isCreditsModalOpen.value = true;
    requiredCredits.value = 0;
    showRequiredCredits.value = false;
    creditsModalView.value = normalizeView(view);
  };

  // 打开积分不足弹窗（显示所需积分）
  const openNotEnoughCreditsModal = (required = 0, view = "all") => {
    console.log("openNotEnoughCreditsModal");
    isCreditsModalOpen.value = true;
    requiredCredits.value = required;
    showRequiredCredits.value = true;
    creditsModalView.value = normalizeView(view);
  };

  // 关闭积分弹窗
  const closeCreditsModal = () => {
    console.log("closeCreditsModal");
    isCreditsModalOpen.value = false;
  };

  return {
    isCreditsModalOpen,
    requiredCredits,
    showRequiredCredits,
    creditsModalView,
    openBuyCreditsModal,
    openNotEnoughCreditsModal,
    closeCreditsModal,
  };
};
